import React from 'react';
import {components} from 'react-select';
import Typography from '@material-ui/core/Typography';
function OptionExceso(props) {
   const {children, ...other} = props;
   const estiloUnaLinea = props.selectProps.unaLinea
      ? {textOverflow: 'ellipsis', overflow: 'hidden', width: '100%', whiteSpace: 'pre'}
      : undefined;
   const indicadorTitulos = props.selectProps.titulos;
   return (
      <components.Option {...other}>
         <Typography
            variant="body1"
            title={indicadorTitulos ? props.children : undefined}
            style={estiloUnaLinea}
         >
            {children}
         </Typography>
      </components.Option>
   );
}
export default OptionExceso;
